"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constant_1 = __importDefault(require("./constant"));
var SEPARATOR = constant_1.default.SEPARATOR;
// Create a callback ID by tenant label + folio ID + timestamp
// Returns a string, e.g.: "KN-233176-1563924675316"
function composeCallbackId(tenantLabel, folioId) {
    var timestamp = new Date().valueOf();
    return [tenantLabel, folioId, timestamp].filter(Boolean).join(SEPARATOR).replace(/\s/g, '');
}
exports.default = composeCallbackId;
